import { Paper, Typography, Box } from '@mui/material';

export const AdPlaceholder = () => {
  return (
    <Paper
      className="ad-placeholder"
      elevation={1}
      sx={{
        padding: 3,
        backgroundColor: '#f9f9f9',
        border: '2px dashed #ccc',
        textAlign: 'center',
        minHeight: { xs: 100, md: 200 },
        display: { xs: 'none', md: 'flex' },
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box>
        <Typography variant="body2" color="text.secondary">
          Advertisement Space
        </Typography>
        <Typography variant="caption" color="text.secondary">
          (Placeholder for future ads)
        </Typography>
      </Box>
    </Paper>
  );
};
